import request from '@/router/axios'

  // 政策公告分页
  export function warrantyPage(params) {
    return request({
      url: '/api/warranty/page',
      method: 'get',
      params
    })
  }
  // 保修详情
  export function warrantyDetail(params) {
    return request({
      url: `/api/warranty/history/list`,
      method: 'get',
      params
    })
  }